import BaseService from '@src/services/BaseService'
import * as storeFile from "@state/store";
import axios from 'axios'

class ExportPresentationJobService extends BaseService {
    constructor() {
        super('export-presentation-jobs')
    }

    getUrl() {
        return `${process.env.VUE_APP_API_ENDPOINT}/${this.filterTenant ? `tenant/${storeFile.default.getters['auth/tenantId']}/`: ''}${this.urlRoute}`
    }

    fetchExportPresentationJobProgress(payload) {
        return axios.post(`${this.getUrl()}/progress`, payload)
    }
}

export default new ExportPresentationJobService()
